<mat-dialog-content>
    <iframe align="center" allowfullscreen frameborder="0" [src]="url">
    </iframe>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center">
    <button mat-button color="primary" mat-dialog-close>
        Close
    </button>
</mat-dialog-actions>